import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'cross', 'Cross', [["path",{"d":"M10 21h4v-9h5v-4h-5v-5h-4v5h-5v4h5l0 9","key":"svg-0"}]]);